import React, { useEffect, useState } from "react";
import Header from "../common/header/Header";
import OperatingHours from "./operatinghours";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import TagInput from "./input-tags";
import PrimaryButton from "../common/buttons/PrimaryButton";
import SecondaryButton from "../common/buttons/SecondaryButton";

import { Toast } from "../common/toast/toast";
import { BackButton } from "../common/back-button/back-button";
import { getCountryStateInformation } from "../../reducer/slices/country-state/get-country-info-slice";
import { useDispatch, useSelector } from "react-redux";
import { getTimezoneList } from "../../reducer/slices/timezone/get-timezone-slice";
import { IconTimer } from "../../assets/icons/icon-timer";

import { useNavigate } from "react-router";

const AddClinic = () => {

    const [organizationName, setOrganizationName] = useState('')
    const [addName, setAddName] = useState('')
    const [addPhoneNumber, setAddPhoneNumber] = useState('')
    const [addPrincipalInvestigator, setAddPrincipalInvestigator] = useState('')
    const [city, setCity] = useState('')
    const [postal, setPostal] = useState('')
    const [addAddress, setAddAddress] = useState('')
    const [addDisease, setAddDisease] = useState([])
    const [selectedTimeZoneName, setSelectedTimeZoneName] = useState("");
    const [selectCountry, setSelectCountry] = useState()
    const [selectedCountryId, setSelectedCountryId] = useState("")
    const [stateList, setStateList] = useState([]);
    const [selectStateName, setSelectStateName] = useState("")
    const [selectedStateId, setSelectedStateId] = useState("")
    const [toasts, setToasts] = useState([]);
    const [timezone, setTimezone] = useState("")
    const [tags, setTags] = useState([]);
    const [hover, setHover] = useState(false);
    
    const dispatch = useDispatch()
    const countryData = useSelector(state => state.country.countryData)
    const timezoneData = useSelector((state) => state.time_zone.data)
    const [isOpen, setIsOpen] = useState(false);
    const handleSelectTimeZoneChange = (e) => {
        const selectedName = e.target.value; // Get the selected timezone
        setSelectedTimeZoneName(selectedName)
        const selectedTimeZone = timezoneData.find((tz) => tz.displayName === selectedName);
        setSelectedTimeZoneId(selectedTimeZone.timezoneID)
    };

    const [smsNumber, getSmsNumber] = useState()
    const [smsFromNumber, setSmsFromNumber] = useState("")

    function getCountryAndStateId(data, stateName) {
        for (const country of data) {
          const state = country.stateResponseModel.find(
            (state) => state.stateName.toLowerCase() === stateName.toLowerCase()
          );
          if (state) {
            return {
              countryID: country.countryID,
              stateID: state.stateID,
            };
          }
        }
        return null; // Return null if no matching state is found
      }

    const handleSelectCountryChange = (e) => {
        const selectedName = e.target.value; // Get the selected timezone
        setSelectCountry(selectedName)
        setSelectStateName("")
        setSelectedStateId("")
        const selectedTimeZone = countryData.find((tz) => tz.countryName === selectedName);
       
        setSelectedCountryId(selectedTimeZone.countryID)
        setStateList(selectedTimeZone.stateResponseModel)
    };

    const handleSelectStateChange = (e) => {
        const selectedName = e.target.value; // Get the selected timezone
        setSelectStateName(selectedName)
        const stateAndCountryId =  getCountryAndStateId(countryData,selectedName)
        setSelectedCountryId(stateAndCountryId.countryID)
        setSelectedStateId(stateAndCountryId.stateID)
    };


    const addOperatingHours = () => {
        setIsOpen(!isOpen)
    }

    useEffect(() => {
        dispatch(getCountryStateInformation({}));
        dispatch(getTimezoneList({}))
    }, [])

    const [getTimezone, setGetTimezone] = useState([]);
    const fetchTimezone = async () => {
        const response = await axios.get(ENDPOINTS.CLINIC.TIMEZONE)
        setGetTimezone(response.data.data)
    }

    const [selectedTimeZoneId, setSelectedTimeZoneId] = useState("");
   
    const handleSelectChange = (e) => {
        const selectedName = e.target.value; // Get the selected timezone
        setTimezone(selectedName)
        const selectedTimeZone = getTimezone.find((tz) => tz.displayName === selectedName);
        setSelectedTimeZoneId(selectedTimeZone.timezoneID)
    };

    const addToast = (message, type) => {
        const id = Date.now();
        setToasts([...toasts, { id, message, type }]);
        setTimeout(() => removeToast(id), 3000); // Auto-dismiss after 3 seconds
    };

    const removeToast = (id) => {
        setToasts(toasts.filter((toast) => toast.id !== id));
    };

    useEffect(() => {
        fetchTimezone()

    }, [selectedTimeZoneId])

    const closePopup = () => {
        setIsOpen(false);
        setPopup({ show: false, message: "", isError: false });
    };

    const [getDataOp, setgetDataOp] = useState([
        
            {
                "day": "Sunday",
                "isChecked": false,
                "time": {
                    "from": null,
                    "to": null
                }
            },
            {
                "day": "Monday",
                "isChecked": true,
                "time": {
                    "from": "08:00:00",
                    "to": "17:00:00"
                }
            },
            {
                "day": "Tuesday",
                "isChecked": true,
                "time": {
                    "from": "08:00:00",
                    "to": "17:00:00"
                }
            },
            {
                "day": "Wednesday",
                "isChecked": true,
                "time": {
                    "from": "08:00:00",
                    "to": "17:00:00"
                }
            },
            {
                "day": "Thursday",
                "isChecked": true,
                "time": {
                    "from": "08:00:00",
                    "to": "17:00:00"
                }
            },
            {
                "day": "Friday",
                "isChecked": true,
                "time": {
                    "from": "08:00:00",
                    "to": "17:00:00"
                }
            },
            {
                "day": "Saturday",
                "isChecked": false,
                "time": {
                    "from": null,
                    "to": null
                }
            }
        
    ]);
    const [inputResponse, setInputResponse] = useState([]);

    const [popup, setPopup] = useState({ show: false, message: "", isError: false });

    // Validations..............

    const [formErrors, setFormErrors] = useState({
        name: '',
        phoneNumber: '',
        smsFromNumber: '',
        principalInvestigator: '',
        address: '',
        disease: '',
        operatingHours: '',
        organizationName: '',
    });

   
    const validateForm = () => {
        const errors = {};
    
        // Validate Location Name
        if (!addName.trim()) {
            errors.name = "Location Name is required.";
        }
    
        // Validate Phone Number
        const phoneNumberPattern = /^[0-9]{10}$/; // Assuming 10-digit phone number
        if (!addPhoneNumber.trim()) {
            errors.phoneNumber = "Phone Number is required.";
        } else if (!phoneNumberPattern.test(addPhoneNumber)) {
            errors.phoneNumber = "Please enter a valid 10-digit phone number.";
        }

         // Validate SMS From Number
        const smsNumberValue = String(
            smsFromNumber || smsNumber || ""
        ).trim();

        const usPhoneRegex = /^\+1\d{10}$/;

        if (!smsNumberValue) {
            errors.smsFromNumber = "SMS From Number is required.";
        } else if (!usPhoneRegex.test(smsNumberValue)) {
            errors.smsFromNumber =
                "SMS From Number must start with +1 and contain exactly 10 digits.";
        }
    
        // Validate Principal Investigator
        if (!addPrincipalInvestigator.trim()) {
            errors.principalInvestigator = "Principal Investigator is required.";
        }
    
        // Validate Time Zone
        if (!selectedTimeZoneName) {
            errors.timezone = "Time Zone is required.";
        }
    
        // Validate Operating Hours
        if (
            !inputResponse ||
            (typeof inputResponse === "string" && !inputResponse.trim()) ||
            (Array.isArray(inputResponse) && inputResponse.length === 0)
        ) {
            errors.operatingHours = "Operating Hours are required.";
        }
    
        // Validate Address
        if (!addAddress.trim()) {
            errors.address = "Address is required.";
        }
    
        // Validate Country
        if (!selectCountry) {
            errors.country = "Country/Region is required.";
        }
    
        // Validate State
        if (!selectStateName) {
            errors.state = "State is required.";
        }
    
        // Validate City
        if (!city.trim()) {
            errors.city = "City is required.";
        }
    
        // Validate Zip Code
        const postalCodePattern = /^[0-9]{5,6}$/; // Adjust as needed for postal code format
        if (!postal.trim()) {
            errors.postal = "Zip Code is required.";
        } else if (!postalCodePattern.test(postal)) {
            errors.postal = "Please enter a valid Zip Code.";
        }
    
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const navigate = useNavigate();
    const goToLogin = () => {
        navigate("/login");
      };
    
    useEffect(() => {
        getSmsNumberInfo();
    }, []);

    const getSmsNumberInfo = async () => {
        try {
            const response = await axios.get(
                ENDPOINTS.LOCATION.GET_SMS_NUMBER
            );
            setSmsFromNumber(response?.data?.data?.smsFromNumber || "")
            //console.log("GET_SMS_NUMBER FULL RESPONSE => ", response.data.data.smsFromNumber);
        } catch (error) {

            addToast(
                error?.response?.data?.message || error.message,
                "error"
            );
        }
    };
    const handleAddClinic = async (e) => {
        e.preventDefault()

       const resBody = {
            "name": addName,
            "phoneNumber": addPhoneNumber,
            "smsFromNumber": smsFromNumber,
            "principalInvestigator": addPrincipalInvestigator,
            "timezoneID": selectedTimeZoneId,
            "operatingHoursJson": getDataOp,
            "operatingHours": "",
            "address":addAddress,
            "locationID": null,
            "countryID": selectedCountryId,
            "stateID": selectedStateId,
            "city": city,
            "zip": postal
          }
        
        if (!validateForm()) {
            
            return; // If validation fails, stop form submission
        }
        try {
            const response = await axios.post(ENDPOINTS.CLINIC.ADD_CLINIC, resBody)
            addToast("Location has been added successfully.", "success")
            setAddName(' ')
            setAddPhoneNumber(' ')
            setAddPrincipalInvestigator(' ')
            setAddAddress(' ')
            setAddDisease([])
            setTimezone('')
            setInputResponse('')
            setTags([])
            setSelectStateName('')
            setSelectedCountryId('')
            setSelectedStateId('');
            setSelectCountry('')
            setOrganizationName('')
            setTimezone('')
            setSelectedTimeZoneName('')
            setSelectedTimeZoneId('')
            localStorage.removeItem('days')
            localStorage.removeItem('weekdays')
            localStorage.removeItem('weekend')
            localStorage.removeItem('time')
        setCity('')
        setStateList('')
        setSmsFromNumber('')
        setPostal('')
           
        }
        catch (error) {
            addToast(error.message, "error")
        }
    }



    return (
        <>
            <Header headertitle="Add Location" backbutton={true} />
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    toast={toast}
                    onClose={() => removeToast(toast.id)}
                />
            ))}
            <div className="main-body w-[80%] p-8 ">
                <form onSubmit={handleAddClinic} className="w-full" noValidate>
                    <p className="mb-5">Keep Locations detail updated for smoother operations and clear communications.</p>
                    <div className="grid grid-cols-2 gap-[24px] pt-3">
                        <div>
                            <label for="clinicName" class="block form_label_color pb-4">
                                Location Name  <span className="aestrick_color">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                // placeholder="Your First Name"
                                value={addName}
                                onChange={(e) => setAddName(e.target.value)}
                            />
                            {formErrors.name && <span className="text-red-500">{formErrors.name}</span>}
                        </div>
                        <div>
                            <label for="phoneNumber" class="block form_label_color pb-4">
                                Phone Number  <span className="aestrick_color">*</span>
                            </label>
                            <input
                                type="text"
                                name="phoneNumber"
                                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                // placeholder="Please enter Phone number"
                                value={addPhoneNumber}
                                onChange={(e) => setAddPhoneNumber(e.target.value)}
                            />
                            {formErrors.phoneNumber && <span className="text-red-500">{formErrors.phoneNumber}</span>}
                        </div>
                       
                  
                        <div className="w-full relative">
                            <label className="block form_label_color pb-4">Time Zone <span className="aestrick_color">*</span></label>
                            <select
                                id="timezone"
                                name="timezone"
                                value={selectedTimeZoneName}
                                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12 appearance-none"
                                onChange={handleSelectTimeZoneChange}
                            >
                                <option value={""} selected disabled>Select Timezone</option>
                                {timezoneData?.map((tz) => (
                                    <option key={tz.timezoneID} value={tz.displayName}>
                                        {tz.displayName}
                                    </option>
                                ))}
                            </select>
                            <span className="absolute right-[20px] top-[65px] transform -translate-y-1/2 pointer-events-none">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                            {formErrors.timezone && (
                                <span className="text-red-500">{formErrors.timezone}</span>
                            )}
                        </div>
                        
                        <div>
                            <label for="principalInvestigator" class="block form_label_color pb-4">
                                Principal Investigator  <span className="aestrick_color">*</span>
                            </label>
                            <input
                                type="text"
                                name="principalInvestigator"
                                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                // placeholder="Principal Investigator"
                                value={addPrincipalInvestigator}
                                onChange={(e) => setAddPrincipalInvestigator(e.target.value)}
                            />
                            {formErrors.principalInvestigator && <span className="text-red-500">{formErrors.principalInvestigator}</span>}
                        </div>
                    </div>
                    <div className="w-full pt-8">

                    <div>
                            <label for="operatingHours" class="block form_label_color pb-4">
                                Operating Hours  <span className="aestrick_color">*</span>
                            </label>
                            <div className="flex relative">
                                <input
                                    type="text"
                                    name="operatinghours"
                                    className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                    // placeholder="Add operating hours"
                                    value={inputResponse && inputResponse}
                                    onClick={addOperatingHours}
                                />
                                <span onClick={addOperatingHours} className="absolute right-[20px] top-3"><IconTimer /></span>
                            </div>
                            {formErrors.operatingHours && <span className="text-red-500">{formErrors.operatingHours}</span>}
                        </div>

                    </div>
                    <div className="w-full pt-8">
                        <label for="address" class="block form_label_color pb-4">
                            Address  <span className="aestrick_color">*</span>
                        </label>
                        <input
                            type="text"
                            name="address"
                            className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                            // placeholder="Please enter Address"
                            value={addAddress}
                            onChange={(e) => setAddAddress(e.target.value)}
                        />
                        {formErrors.address && <span className="text-red-500">{formErrors.address}</span>}
                    </div>
                    <div className="grid grid-cols-2 gap-[24px] mt-8 mb-[75px]">
                        <div className="w-full relative">
                            <label className="block form_label_color pb-4">Country/Region <span className="aestrick_color">*</span></label>
                            <select
                                id="countyr"
                                name="country"
                                value={selectCountry}
                                className="border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                                onChange={handleSelectCountryChange}
                            >
                                <option value={""} selected disabled>Select Country</option>
                                {countryData?.map((tz) => (
                                    <option key={tz.countryID} value={tz.countryName}>
                                        {tz.countryName}
                                    </option>
                                ))}
                            </select>
                            <span className="absolute right-[20px] top-[65px] transform -translate-y-1/2 pointer-events-none">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                            {formErrors.country && (
                                <span className="text-red-500">{formErrors.country}</span>
                            )}
                        </div>
                        <div className="w-full relative">
                            <label className="block form_label_color pb-4">State <span className="aestrick_color">*</span></label>
                            <select
                                id="state"
                                name="state"
                                value={selectStateName}
                                className="border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                                onChange={handleSelectStateChange}
                            >
                                <option value={""} selected disabled></option>
                                {stateList && stateList.length && stateList.map((tz) => (
                                    <option key={tz.stateID} value={tz.stateName}>
                                        {tz.stateName}
                                    </option>
                                ))}
                            </select>
                            <span className="absolute right-[20px] top-[65px] transform -translate-y-1/2 pointer-events-none">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                            {formErrors.state && (
                                <span className="text-red-500">{formErrors.state}</span>
                            )}
                        </div>
                        <div>
                            <label for="principalInvestigator" class="block form_label_color pb-4">
                                City  <span className="aestrick_color">*</span>
                            </label>
                            <input
                                type="text"
                                name="principalInvestigator"
                                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                // placeholder="Please enter city"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                            {formErrors.city && <span className="text-red-500">{formErrors.city}</span>}
                        </div>
                        <div>
                            <label for="organization_name" class="block form_label_color pb-4">
                                Zip Code  <span className="aestrick_color">*</span>
                            </label>
                            <input
                                type="text"
                                name="organization_name"
                                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                // placeholder="Please enter Postal Code"
                                value={postal}
                                onChange={(e) => setPostal(e.target.value)}
                            />
                            {formErrors.postal && <span className="text-red-500">{formErrors.postal}</span>}
                        </div>
                        <div>
                            <div className="mb-4 flex items-center gap-2">
                                <label htmlFor="ai-sms-number-twilio" className="block form_label_color">
                                    AI SMS Number (Twilio) <span className="aestrick_color">*</span>
                                </label>
                                <div className="relative group flex items-center justify-center">
                                    <button
                                        type="button"
                                        onMouseEnter={() => setHover(true)}
                                        onMouseLeave={() => setHover(false)}
                                        aria-label="Information about AI SMS Number (Twilio)"
                                    >
                                        {!hover ? (<>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18.0003 10.0003C18.0003 5.58223 14.4187 2.00065 10.0007 2.00065C5.58255 2.00065 2.00098 5.58223 2.00098 10.0003C2.00098 14.4184 5.58255 18 10.0007 18C14.4187 18 18.0003 14.4184 18.0003 10.0003Z" stroke="#1B2A3D" stroke-width="1.5" />
                                                <path d="M10.1935 14.0029V10.0031C10.1935 9.62598 10.1935 9.43743 10.0764 9.32028C9.95922 9.20312 9.77066 9.20312 9.39355 9.20312" stroke="#1B2A3D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.99301 6.80469H10.0002" stroke="#1B2A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </>) : (<>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18.0003 10.0003C18.0003 5.58223 14.4187 2.00065 10.0007 2.00065C5.58255 2.00065 2.00098 5.58223 2.00098 10.0003C2.00098 14.4184 5.58255 18 10.0007 18C14.4187 18 18.0003 14.4184 18.0003 10.0003Z" fill="#245CEA" />
                                                <path d="M10.1935 14.0029V10.0031C10.1935 9.62598 10.1935 9.43743 10.0764 9.32028C9.95922 9.20312 9.77066 9.20312 9.39355 9.20312" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.99301 6.80469H10.0002" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg></>)}






                                    </button>

                                    <div
                                        className="pointer-events-none font-semibold absolute left-[30px] top-[0px] opacity-0 z-20 w-[400px] rounded-md border border-[#E4E4E4] bg-white px-3 py-2 text-[11px] leading-[1.35] text-[#4A4A4A] shadow-[0_6px_20px_rgba(0,0,0,0.08)] transition-opacity duration-200 group-hover:opacity-100 group-focus-within:opacity-100"
                                    >
                                        Changing this number requires corresponding Twilio configuration updates.
                                        Please ensure the Twilio phone number and SMS settings are configured
                                        correctly to avoid delivery issues.
                                    </div>
                                </div>
                            </div>
                            <input
                                id="ai-sms-number-twilio"
                                type="text"
                                name="AI SMS Number (Twilio)"
                                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                                value={smsFromNumber}
                                onChange={(e) => setSmsFromNumber(e.target.value)}
                            />
                            {formErrors.smsFromNumber && <span className="text-red-500">{formErrors.smsFromNumber}</span>}
                        </div>
                    </div>
                    <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 pl-[36px] bottom-0 w-full -ml-8 bg-white pl-8 flex gap-[20px]">
                        <button type="submit" className="btn-primary-base-bar primary_btn" >Add</button>
                        <BackButton />
                    </div>

                </form>
            </div>

            {/* popup for operating hours */}
            {isOpen && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-2 relative">
                        <button
                            onClick={closePopup}
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                        >
                            ✕
                        </button>
                        <OperatingHours
                            getDataOp={getDataOp}
                            setgetDataOp={setgetDataOp}
                            isOpen={isOpen}
                            setIsOpen={setIsOpen}
                            setInputResponse={setInputResponse}
                            inputResponse={inputResponse}
                        />
                    </div>
                </div>
            )
            }

            {/* Popup on submission */}
            {popup.show && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 relative">
                        <div className={`popup ${popup.isError ? "error" : "success"}`}>
                            <p>{popup.message}</p>
                            <button
                                onClick={closePopup}
                                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default AddClinic;